<template>
    <div class="lang">
        <div class="info">
            <h3 class="bullet01">门诊预约和诊疗时间</h3>
            <div class="table mt20">
                <table>
                    <colgroup>
                        <col style="width: calc(100% / 4)">
                        <col style="width: calc(100% / 4)">
                        <col style="width: calc(100% / 4)">
                        <col style="width: calc(100% / 4)">
                    </colgroup>
                    <thead>
                        <tr>
                            <th colspan="2">类别</th>
                            <th colspan="2">门诊预约和服务时间</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td rowspan="2">诊疗预约</td>
                            <td rowspan="2">平日</td>
                            <td>上午</td>
                            <td>08:30 ~ 11:45</td>
                        </tr>
                        <tr>
                            <td>下午</td>
                            <td>12:30 ~ 16:45</td>
                        </tr>
                        <tr>
                            <td rowspan="2">诊疗时间</td>
                            <td rowspan="2">平日</td>
                            <td>上午</td>
                            <td>09:00 ~ 12:00</td>
                        </tr>
                        <tr>
                            <td>下午</td>
                            <td>13:00 ~ 17:00</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <p class="mt10 font-sub">
                ※ 星期六不提供服务.
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        components: {
        },
        mounted() {
        },
    }
</script>